import _ from "lodash";

export default {
  showVesselDetail: (state) => {
    return state.showVesselDetail;
  },
  showPlotDetail: (state) => {
    return state.showPlotDetail;
  },
  showPrivatePlotDetail: (state) => {
    return state.showPrivatePlotDetail;
  },
  getCountryName: (state) => (countryCode) => {
    let cc = state.countryCodes.filter((country) => country.id === countryCode);
    return cc.length > 0 ? cc[0].name_localized : null;
  },
  getCountryAlpha2: (state) => (countryCode) => {
    let cc = state.countryCodes.filter((country) => country.id === countryCode);
    return cc.length > 0 ? cc[0].alpha2.toLowerCase() : null;
  },
  getVesselDetail: (state) => {
    return state.vesselDetail;
  },
  isMonitoring: (state) => (vesselId) => {
    let result = state.monitoringVessels.filter(function (value) {
      return value.id === vesselId;
    });
    return result.length !== 0;
  },
  isMonitoringLimit: (state) => {
    return state.monitoringVessels.length >= 5;
  },
  isOwnVessel: (state) => (vesselId) => {
    let result = state.ownVessels.filter(function (value) {
      return value.id === vesselId;
    });
    return result.length !== 0;
  },
  getPlotDetail: (state) => {
    return state.plotDetail;
  },
  isDisplayedVesselDetail: (state) => (vesselId) => {
    if (!state.vesselDetail) return false;
    return state.vesselDetail.id === vesselId;
  },
  hasWakes: (state) => (vesselId) => {
    return !!state.wakes.get(vesselId);
  },
  getMetoceanInitialDatetime: (state) => {
    return state.metoceanInitialDatetime;
  },
  getCurrentMetoceanSourceLayerId: (state) => {
    if (!state.currentWeatherSourceLayerId) {
      return null;
    }
    return state.currentWeatherSourceLayerId;
  },
  getCurrentContourSourceLayerId: (state) => {
    if (!state.updateContourSourceLayer) {
      return null;
    }
    return state.updateContourSourceLayer.newSourceLayerId;
  },
  getWeatherDisplayedUnixTime: (_state, getters) => {
    if (getters.getMetoceanDisplayedUnixTime)
      return getters.getMetoceanDisplayedUnixTime;
    if (getters.getContourDisplayedUnixTime)
      return getters.getContourDisplayedUnixTime;
    return null;
  },
  getMetoceanDisplayedUnixTime: ({
    showWeatherMenu,
    updateMetoceanSourceLayer,
  }) => {
    return (
      (showWeatherMenu &&
        updateMetoceanSourceLayer &&
        updateMetoceanSourceLayer.displayedUnixTime) ||
      null
    );
  },
  getContourDisplayedUnixTime: ({ showContour, updateContourSourceLayer }) => {
    return (
      (showContour &&
        updateContourSourceLayer &&
        updateContourSourceLayer.displayedUnixTime) ||
      null
    );
  },
  getOffingWavePointNextId: (state) => {
    if (state.offingWavePoints.length === 0) {
      return 1;
    } else {
      let copyOffingWavePoints = _.cloneDeep(state.offingWavePoints);
      let id;
      copyOffingWavePoints.some((v, i) => {
        if (i + 1 !== v.pointId) {
          id = i + 1;
          return true;
        }
      });
      if (typeof id === "undefined") {
        return copyOffingWavePoints.length + 1;
      } else {
        return id;
      }
    }
  },
  getOffingWavePoint: (state) => (pointId) => {
    let res = state.offingWavePoints.find((el) => el.pointId === pointId);
    return _.cloneDeep(res);
  },
  isLimitOffingWavePoint: (state) => {
    return state.offingWavePoints.length >= 10;
  },
  /** storeに格納している場合はstoreから返す。ない場合はapiからフェッチして返す */
  getLastVesselPosition: (_state, getters) => (vesselId) => {
    return getters.getLastVesselPositionMap[vesselId];
  },
  // getLastVesselPosition時にidでlastPositionを引けるようにキャッシュ
  getLastVesselPositionMap: (state) => {
    return state.lastVesselPositions.reduce((prev, vessel) => {
      if (vessel && vessel.vessel_id) {
        prev[vessel.vessel_id] = vessel;
      }
      return prev;
    }, {});
  },
  getUniqueVesselIdsAcrossFavorites: (state) => {
    let vesselIds = [];
    state.favoriteList.forEach((favorite) => {
      favorite.groupList.forEach((group) => {
        group.vessels.forEach((vesselId) => {
          vesselIds.push(vesselId);
        });
      });
    });
    return Array.from(new Set(vesselIds));
  },
};
